<script lang="ts">
  import { CenterImage } from '@centerhealth/fe/center-kit';
  import { createSource, createSourceSet, ISrcSetData } from '@centerhealth/fe/images';

  const imageObject: ISrcSetData = {
    sourceUrl: '/assets/images/sync-bg.webp',
  };
</script>

<section>
  <div class="container flex flex-col mx-auto my-7">
    <CenterImage>
      <img
        class="mb-2 md:mb-0 md:order-last w-max	object-contain"
        width="500"
        height="650"
        srcset={createSourceSet(imageObject)}
        src={createSource(imageObject.sourceUrl)}
        alt=""
      />
    </CenterImage>
    <h2 class="text-center leading-tight">Sync with all your existing apps & devices</h2>
    <p class="text-center text-lg xl:text-xl text-gray mt-2 xl:px-7 xxl:px-10">
      Center makes it easy to bring all your diabetes data under one roof, adding valuable context
      to your readings.
    </p>
  </div>
</section>
